<div class="company-summary">
  <ng-container *appLoad="let data of load$; trackingName: 'company-summary'">
    <!-- details -->
    <h4>Details</h4>

    <lds-card [isClickable]="true" (click)="edit()">
      <div class="company-summary__details">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Name"
              [text]="data.company.name"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Trading name"
              [text]="data.company.tradingName"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <country-wrapper>
              <ng-template country="NZ">
                <app-summary-field
                  label="NZBN"
                  [text]="
                    data.company.businessNumber | nzbn
                  "></app-summary-field>
              </ng-template>
              <ng-template countryDefault>
                <app-summary-field
                  label="ABN"
                  [text]="
                    data.company.businessNumber | abn
                  "></app-summary-field>
              </ng-template>
            </country-wrapper>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <country-wrapper>
              <ng-template country="NZ">
                <app-summary-field
                  label="Company number"
                  [text]="
                    data.company.companyNumber | nzcn
                  "></app-summary-field>
              </ng-template>
              <ng-template countryDefault>
                <app-summary-field
                  label="ACN"
                  [text]="data.company.companyNumber | acn"></app-summary-field>
              </ng-template>
            </country-wrapper>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              [label]="startDateLabel"
              [text]="
                data.company.startDate | date : 'dd/MM/yyyy'
              "></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="GST registration date"
              [text]="
                data.company.gstRegistrationDate | date : 'dd/MM/yyyy'
              "></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Business nature"
              [text]="data.company.businessNature"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Accountant name"
              [text]="data.company.accountantName"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Accountant number"
              [text]="data.company.accountantPhone"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Status"
              [text]="data.company.status"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Contact type"
              [text]="data.company.contactType"></app-summary-field>
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <app-summary-field
              label="Send marketing comms."
              [text]="
                data.company.marketingCommunications | yesNo
              "></app-summary-field>
          </div>
          <div
            class="col-12 col-sm-6 col-lg-3"
            *ngIf="data.company.contactType | displayAffiliateId">
            <app-summary-field
              label="Affiliate ID"
              [text]="data.company.nmbAffiliateId"></app-summary-field>
          </div>
        </div>
      </div>
      <div class="company-summary__action">
        <lds-icon-button icon="edit" appearance="default" [isRounded]="true">
        </lds-icon-button>
      </div>
    </lds-card>

    <!-- addresses -->
    <ng-container *ngIf="data.company.address || data.company.registeredOffice">
      <h4>Addresses</h4>

      <lds-card [isClickable]="true" (click)="edit()">
        <div class="company-summary__details mb-md">
          <div class="row">
            <div class="col-12 col-lg-6" *ngIf="data.company.address">
              <div class="text-label">Address</div>
              <div class="text-data">
                {{ data.company.address | agpSharedReadableAddress | summary }}
              </div>
            </div>
            <div class="col-12 col-lg-6" *ngIf="data.company.registeredOffice">
              <div class="text-label">Registered office</div>
              <div class="text-data">
                {{
                  data.company.registeredOffice
                    | agpSharedReadableAddress
                    | summary
                }}
              </div>
            </div>
          </div>
        </div>
      </lds-card>
    </ng-container>

    <!-- directors -->
    <ng-container
      *ngIf="data.company.directors && data.company.directors.length > 0">
      <h4>Directors</h4>

      <lds-card [isClickable]="true" (click)="edit()">
        <div class="company-summary__details mb-md">
          <!-- TODO: responsive layout on small devices [future release] -->
          <div class="row">
            <div class="col-6">
              <div class="text-label">Name</div>
            </div>
          </div>

          <ng-container *ngFor="let director of data.company.directors">
            <div class="row">
              <div class="col-6">
                <div class="text-data">{{ contactName(director) }}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </lds-card>
    </ng-container>

    <!-- ownership -->
    <ng-container *ngIf="data.company.shareholders?.length > 0">
      <h4>Shareholders</h4>

      <lds-card [isClickable]="true" (click)="edit()">
        <div class="company-summary__details mb-md">
          <!-- TODO: responsive layout on small devices [future release] -->
          <div class="row">
            <div class="col-6">
              <div class="text-label">Name</div>
            </div>
            <div class="col">
              <div class="text-label">Share (%)</div>
            </div>
          </div>

          <ng-container *ngFor="let shareholder of data.company.shareholders">
            <div class="row">
              <div class="col-6">
                <div class="text-data">{{ contactName(shareholder.id) }}</div>
              </div>
              <div class="col">
                <div class="text-data">
                  {{ shareholder.ownership | percent }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </lds-card>
    </ng-container>

    <div class="tags-summary">
      <h4>Tags</h4>
      <lds-card>
        <div class="tags-summary__details">
          <app-tag-input
          [entityId]="companyId"
          [entityType]="TagEntityType.Companies"
            [readonly]="false"
            [showLabel]="false">
          </app-tag-input>
        </div>
      </lds-card>
    </div>

    <h4>Referrer Arrangement</h4>

    <spark-contacts-referrer-arrangement-summary
      [referrerArrangement]="data.company.referrerArrangement"
      (clicked)="edit()">
    </spark-contacts-referrer-arrangement-summary>
  </ng-container>
</div>
